import React from 'react';
import { styled, TextV2 } from '@withjoy/joykit';
import { EventConfiguration } from '@apps/workspace/Workspace';
import { useEventPhotoByEventIdQuery } from '@graphql/generated';

const CountdownContainer = styled.div<{ eventPhoto: string }>`
  width: 100%;
  height: 100%;
  align-items: center;
  padding: 16px;
  background-size: cover;
  background-position: center;
  background-image: url(${props => props.eventPhoto});
`;

export const EventCountdown: React.FC<{ eventConfiguration?: EventConfiguration }> = ({ eventConfiguration }) => {
  const { data, loading } = useEventPhotoByEventIdQuery({
    variables: { eventId: eventConfiguration?.eventId ?? '' },
    batchMode: 'off',
  });

  if (loading) {
    return <TextV2>Loading...</TextV2>;
  }
  const eventPhotoUrl = data?.event?.photo?.url ?? '';
  return (
    <CountdownContainer eventPhoto={eventPhotoUrl}>
      <p style={{ color: 'rgba(255,255,255,0.85', width: '100%', textAlign: 'center', textShadow: `0px 1px 2px rgba(0,0,0,0.3)` }}>
        {eventConfiguration?.eventDisplayName ?? 'Untitled Event'}
      </p>
      <p style={{ color: 'rgba(255,255,255,0.85', width: '100%', textAlign: 'center', textShadow: `0px 1px 2px rgba(0,0,0,0.3)` }}>
        {eventConfiguration?.date?.dateString ?? eventConfiguration?.date?.milliseconds ?? 'No Date Set'}
      </p>
    </CountdownContainer>
  );
};

/*

        <CountdownContainer>
            <TextV2 color={'rgba(255,255,255,0.85'}>Event Countdown</TextV2>
            <TextV2 color={'rgba(255,255,255,0.85'}>Event Countdown</TextV2>

        </CountdownContainer>
*/
